import React, { useEffect } from "react";
import { useEquipmentManagementStore } from "../../../store/masterDataStore";
import { EquipmentManagementType } from "../../../types/api";
import { useNavigate } from "react-router-dom";
import { Wrench } from "lucide-react";

const EquipmentManagementLanding: React.FC = () => {
  const { equipmentManagement, fetchAllEquipmentManagement } =
    useEquipmentManagementStore();

  const navigate = useNavigate();
  useEffect(() => {
    fetchAllEquipmentManagement();
  }, [fetchAllEquipmentManagement]);
  const handleEquipmentTypeClick = (equipment: EquipmentManagementType) => {
    navigate(
      `/equipment-management/equipment-inventory-registration/${equipment._id}`,
      {
        state: {
          _id: equipment._id,
          equipmentName: equipment.equipmentName,
          equipmentDescription: equipment.equipmentDescription,
        },
      },
    );
  };
  return (
    <div className="w-full py-4 px-2">
      <div className="w-full mt-14 mb-6 ">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div>
            <h1 className="text-2xl font-semibold text-gray-800 mb-6">
              Equipment Management
            </h1>

            <p className="text-gray-600">
              Select an equipment type to view and manage inventory
            </p>
          </div>
        </div>
      </div>
      <div className="w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {equipmentManagement.map((equipment) => (
            <div
              key={equipment._id}
              onClick={() => handleEquipmentTypeClick(equipment)}
              className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:scale-105 border border-gray-200 overflow-hidden"
            >
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    {/* <img
                      src={equipmentType.icon}
                      alt={equipmentType.name}
                      className="w-8 h-8 object-contain"
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = images.assetsIcon;
                      }}
                    /> */}
                    <Wrench />
                  </div>
                  {/* {equipmentType.count && (
                  <span className="bg-blue-600 text-white text-sm font-medium px-3 py-1 rounded-full">
                    {equipmentType.count} items
                  </span>
                )} */}
                </div>

                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {equipment.equipmentName}
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed">
                  {equipment.equipmentDescription}
                </p>

                <div className="mt-4 flex items-center text-[#00A8A5] font-medium">
                  <span>Manage Equipment</span>
                  <svg
                    className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EquipmentManagementLanding;
